import { DateTime } from '@mode-switch/express';
import { format, addMinutes, startOfWeek } from 'date-fns';
import { EncField } from '@mode-vegas/vegas';

import { SchemaModel, ChartDate } from '@mode/charts/util-vegas';

export function formatValue(model: SchemaModel, encField: EncField, value: any): string | null | undefined {
  const field = model.compileEncField(encField);
  if (value == null) {
    return null;
  }

  if (field.hasDateFunc) {
    if (field.hasDatePart) {
      switch (field.dateFuncUnit) {
        case DateTime.Unit.Quarter:
          return ChartDate.makeDatePartQuarterName(value);
        case DateTime.Unit.Month:
          return ChartDate.makeDatePartMonthName(value);
        case DateTime.Unit.Weekday:
          return ChartDate.makeDatePartWeekdayName(value);
        case DateTime.Unit.Day:
          return `Day ${value.toString()}`;
        case DateTime.Unit.Hour:
          return `Hour ${value.toString()}`;
        case DateTime.Unit.Minute:
          return `Minute ${value.toString()}`;
        case DateTime.Unit.Second:
          return `Second ${value.toString()}`;
        default:
          return value.toString();
      }
    } else {
      const date = new Date(+value);
      if (date.toString() === 'Invalid Date') {
        return null;
      }

      switch (field.dateFuncUnit) {
        case DateTime.Unit.Year:
          return format(addMinutes(date, date.getTimezoneOffset()), 'y');
        case DateTime.Unit.Quarter:
          return format(addMinutes(date, date.getTimezoneOffset()), 'QQQ y');
        case DateTime.Unit.Month:
          return format(addMinutes(date, date.getTimezoneOffset()), 'MMM y');
        case DateTime.Unit.Week:
          const dateWithOffset = addMinutes(date, date.getTimezoneOffset());
          const firstDayOfWeek = startOfWeek(dateWithOffset);
          return format(firstDayOfWeek, 'MMM d y');
        case DateTime.Unit.Day:
          return format(addMinutes(date, date.getTimezoneOffset()), 'MMM d y');
        case DateTime.Unit.Hour:
          return format(addMinutes(date, date.getTimezoneOffset()), 'haaa MMM d y');
        case DateTime.Unit.Minute:
          return format(addMinutes(date, date.getTimezoneOffset()), 'h:mmaaa MMM d y');
        case DateTime.Unit.Second:
          return format(addMinutes(date, date.getTimezoneOffset()), 'h:mm:ssaaa MMM d y');
        default:
          return format(addMinutes(date, date.getTimezoneOffset()), 'LL/d/y');
      }
    }
  } else {
    return value;
  }
}
